// Open/close the report modal <dialog>. Delegated so it survives Turbo nav.
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-report-open]')
  if (opener) {
    const dialog = document.getElementById(opener.getAttribute('data-report-open'))
    if (dialog && typeof dialog.showModal === 'function') { event.preventDefault(); dialog.showModal() }
    return
  }
  const closer = event.target.closest('[data-report-close]')
  if (closer) {
    const dialog = document.getElementById(closer.getAttribute('data-report-close'))
    if (dialog) { event.preventDefault(); dialog.close() }
  }
})

// Click on the dialog backdrop closes it.
document.addEventListener('click', (event) => {
  const dialog = event.target
  if (dialog.nodeName === 'DIALOG' && dialog.classList.contains('report-dialog')) {
    const r = dialog.getBoundingClientRect()
    const outside = event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom
    if (outside) dialog.close()
  }
})
